import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { imgIxParams } from 'app/constants/img-ix-params';

import { AppStateService } from 'app/services/app-state.service';
import { AuthService } from 'app/services/auth.service';
import { ThemeService } from 'app/services/theme.service';
import { UserService } from 'app/services/user.service';

import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';
@Component({
  selector: 'app-nav-user-widget',
  standalone: true,
  imports: [SvgLoaderComponent, CommonModule],
  templateUrl: './nav-user-widget.component.html',
  styleUrl: './nav-user-widget.component.scss'
})
export class NavUserWidgetComponent {
  @ViewChild('menu') menu!: ElementRef;
  @Input() limited: boolean = false;
  
  showUserMenu: boolean = false;
  userProfile: any = null;
  optimizedProfileImgURL: string;
  currentTheme: string = 'dark';
  menuListener: any;

  constructor(private authService: AuthService, private router: Router, private renderer: Renderer2,
     private userService: UserService, private themeService: ThemeService, private appState: AppStateService) { }

  ngOnInit(): void {
    this.currentTheme = this.themeService.getCurrentTheme();
    this.userService.userProfile$
      .subscribe(profile => {
        this.userProfile = profile;
        this.optimizedProfileImgURL = this.userProfile?.profileImgURL ? this.userProfile?.profileImgURL + imgIxParams.profile.md : null;
      });
  }

  onShowUserMenu() {
    if (!this.showUserMenu) {
      setTimeout(() => {
        this.menuListener = this.renderer.listen('document', 'click', (e: Event) => {
          if (!this.menu.nativeElement.contains(e.target)) {
            this.showUserMenu = false;
            this.menuListener?.(); // cleanup
          }
        });
      }, 10);
      this.showUserMenu = true;
    } else {
      this.showUserMenu = false;
      this.menuListener?.();
    }
  }
  

  onClickMenuLink(route: string) {
    this.showUserMenu = false;
    this.menuListener();
    this.router.navigate([route])
  }

  async onToggleTheme() {
    await this.themeService.toggleTheme();
    this.currentTheme = this.themeService.getCurrentTheme();
    this.themeService.setThemeColorMeta(this.currentTheme);
  }
  
  async onClickSignOut() {
    try {
      await this.userService.stopListeningToProfile();
      await this.authService.signOut();
    } catch (err) {
      console.error('Error ending session', err);
    } finally {
      this.userProfile = null;
      this.appState.resetAppState();
      this.router.navigate(['login']);
      this.showUserMenu = false;
    }
  }

}
